import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LayoutContent, LayoutContentBody, LayoutContentHeader, LayoutControls, ContentFrame, Button, } from '@pinwheel/origami';
import ProviderButton from '../../components/ProviderButton';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import { useAppDispatch, useAppSelector } from '../../state';
import { selectMatchedPlatforms, setUsingMultiSupplierEligibility, } from '../../state/slices/slice-link-api';
import { setSelectedPlatform } from '../../state/slices/slice-provider-entity';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { EventSurface } from '../../types/events';
import { updateEventSource } from '../../state/slices/slice-segment';
import eventQueue from '../../events/queue';
import { cleanPartnerBasedPlatformNames } from '../../utils/partner-based-string-cleaning';
import { selectFeatureFlags } from '../../state/slices/slice-link-params';
export default function MultipleResults() {
    var navigate = useLinkNavigate();
    var featureFlags = useSelector(selectFeatureFlags);
    var getLocalizedString = useGetLocalizedString();
    var matchedPlatforms = useAppSelector(selectMatchedPlatforms);
    var dispatch = useAppDispatch();
    var createOnClickHandler = function (platform) { return function () {
        dispatch(setSelectedPlatform(platform));
        dispatch(setUsingMultiSupplierEligibility(true));
        navigate('/link-api/login');
    }; };
    useEffect(function () {
        dispatch(updateEventSource(EventSurface.PLATFORM_ELIGIBILITY_LOOKUP_RESULTS));
        eventQueue.emit('impression', {});
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (React.createElement(ContentFrame, null,
        React.createElement(LayoutContent, null,
            React.createElement(LayoutContentHeader, { title: getLocalizedString('MS_ELIGIBILITY_MULTIPLE_ACCOUNTS_TITLE'), subtitle: getLocalizedString('MS_ELIGIBILITY_MULTIPLE_ACCOUNTS_SUBITLE') }),
            React.createElement(LayoutContentBody, null, matchedPlatforms.map(function (matchedPlatform) { return (React.createElement(ProviderButton, { eventId: "MSE-selectProvider", logoUrl: matchedPlatform.platform.logoUrl, key: cleanPartnerBasedPlatformNames(matchedPlatform.platform.name), platformName: cleanPartnerBasedPlatformNames(matchedPlatform.platform.name), employerName: matchedPlatform.employerName, onClick: createOnClickHandler(matchedPlatform.platform) })); }))),
        !featureFlags.hideNoneOfTheseOnPrematch && (React.createElement(LayoutControls, null,
            React.createElement(Button, { eventId: "MSE-goToSearch", variant: "ghost", onClick: function () { return navigate('/search/search'); } }, getLocalizedString('MS_ELIGIBILITY_MULTIPLE_ACCOUNTS_SKIP'))))));
}
